// src/index.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient();
const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* Optional Suspense if you lazy-load some pages */}
        <React.Suspense fallback={<div className="p-10 text-center">Loading...</div>}>
          <App />
        </React.Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
